import { BaseFiltersInput, UserFiltersInput, FilterInput } from "@core/store/types/common/statistic/generic/statisticFilters";

export const prepareBaseFilters = (filters: any): BaseFiltersInput => {
  const {
    advertiserId,
    webmasterId,
    bunchId,
    flowId,
    offerId,
    managerId,
    countryId,
    externalWebmasterId,
    withdrawType,
    currency,
    vertical,
    utmCampaign,
    utmContent,
    utmMedium,
    utmSource,
    utmTerm
  } = filters;
  
  const dateStart = filters.datepicker?.dateStart;
  const dateEnd = filters.datepicker?.dateEnd;
  
  return {
    advertiserId,
    webmasterId,
    bunchId,
    flowId,
    offerId,
    managerId,
    countryId,
    externalWebmasterId,
    withdrawType,
    currency,
    vertical,
    utmCampaign,
    utmContent,
    utmMedium,
    utmSource,
    utmTerm,
    dateStart,
    dateEnd
  };
};

export const prepareUserFilters = (filters: any, baseFilters: any): UserFiltersInput => {
  baseFilters = baseFilters ?? prepareBaseFilters(filters);
  const { webmasterId, advertiserId } = filters;

  return {
    ...baseFilters,
    webmasterId,
    advertiserId
  };  
};

export const filterFilters = (filters: FilterInput, excludeKeys: Array<keyof FilterInput> = []) => {
  // Убираем лишние фильтры (например для списка вебов не нужен фильтр по webmasterId)
  return Object.fromEntries(
    Object.entries(filters).map(([key, value]) => {
      const isExcluded = excludeKeys.includes(key as keyof FilterInput);
      return [key, isExcluded ? null : value];
    })
  );
};
